import { createSlice } from '@reduxjs/toolkit';

export const ArlSlice = createSlice({
    name: 'arl',
    initialState: {
        arl_list: [],
        arl_list_select: []
    },
    reducers: {
        setArlRedux: ( state, { payload } ) => {
            state.arl_list  =  payload;
        },
        setCajaArlSelectRedux: ( state, { payload } ) => {
            state.arl_list_select  =  payload;
        },
        
    }
});


// Action creators are generated for each case reducer function
export const { setArlRedux, setCajaArlSelectRedux } = ArlSlice.actions;